import { useEffect } from 'react';
import { useMultipleImageStore } from '../../store/multiple-images-store/useMultipleImagesStore';



export const useUpdateImage = (id, combinedImages) => {
    const { setImageData } = useMultipleImageStore();

    useEffect(() => {
        if (!id) return;
        setImageData(id, combinedImages);
    }, [id, combinedImages, setImageData]);

};
